import React, {useEffect, useState} from 'react';
import {Modal} from 'react-bootstrap';
import {adminHttp} from "~/Admin/services/http";
import AdminLangForm from "~/Admin/AdminMultilang/AdminLanguages/AdminLangForm";

const AdminEditLanguage = ({children, language, onChange, ...rest}) => {

    const [show, setShow] = useState(false);
    const [error, setError] = useState(null);

    const [form, setForm] = useState({
        code: language.code,
        name: language.name,
        display_order: language.display_order,
        rtl: language.rtl,
    });

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleSubmit = () => {
        adminHttp
            .put('/languages/' + language.id, form)
            .then(res => {
                setError(null);
                setShow(false);
                onChange();
            }).catch((error) => {
            setError(error.response?.data);
        });
    };

    return (
        <>
            <a {...rest} onClick={handleShow}>{children}</a>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Language</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving language!"}
                        </div>
                    )}

                    <AdminLangForm values={form} onChange={setForm} errors={error?.errors} />

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary btn-xs" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-primary btn-xs" onClick={handleSubmit}>
                        Save Language
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}


export default AdminEditLanguage;
